exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#coordinates[data-v-41a68145]{display:none;padding:4rem}", ""]);

// exports
